import {CalculatorCondition} from "../../model/CalculatorCondition";
import {ILogService} from "angular";

interface AbstractConditionDescriptionComponentScope {
    condition: CalculatorCondition;

}

export abstract class AbstractConditionDescriptionComponent {

    private condition: CalculatorCondition;
    private $scope: AbstractConditionDescriptionComponentScope;
    private $log: ILogService;

    static instance = (controller: any,
                       tempate: string) => ({
        template: tempate,
        controller: ['$scope', '$log', controller],
        bindings: {
            condition: '<'
        }
    });

    constructor($scope: AbstractConditionDescriptionComponentScope,
                $log: ILogService) {
        this.$scope = $scope;
        this.$log = $log;
    }

    $onInit = () => {
        this.$scope.condition = this.condition;
        this.$log.debug(`Finished mounting the [${this.condition.conditionTitle}] descriptor`)
    };

}